
import { pagingDataUtilities } from '../common';

export const pagingActions = pagingDataUtilities.pagingActions('responses', 'paging');

export const actionTypes = {
  APPLY_FILTER: 'responses.apply-filter',
  ...pagingActions.actionTypes,
};

export const changePageNumber = (page) => pagingDataUtilities.changePage(page, pagingActions);
export const changePerPageNumber = (perPage) => pagingDataUtilities.changePerPage(perPage, pagingActions);
export const changeSort = (newSort) => pagingDataUtilities.changeSort(newSort, pagingActions, ['responses', 'pagingData']);

/**
 * Sets the current filter criteria for the request to get all responses.
 * @param {*} search search based on form name
 * @param {*} siteId the site to limit the search results to
 * @param {*} programId the program to limit the search results to
 */
export function applyFilter(search, siteId, programId) {
  return {
    type: actionTypes.APPLY_FILTER,
    search,
    siteId,
    programId,
  }
}



// WEBPACK FOOTER //
// src/responses/responses.actions.js